import {AnyAction} from 'redux'

export const owner = (state = false, action: AnyAction): boolean => {
  switch (action.type) {
    default:
      return state
  }
}
